import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  selectProcessMiningLoading,
  selectProcessMiningCompleted,
  selectProcessMiningError,
  setProcessMiningLoading,
  setProcessMiningError,
  clearProcessMiningState,
  selectProcessMiningMessage,
} from '../../../../reducers/processMiningReducer';

export const useProcessMining = (funnelMapId: string) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectProcessMiningLoading(funnelMapId));
  const isCompleted = useSelector(selectProcessMiningCompleted(funnelMapId));
  const error = useSelector(selectProcessMiningError(funnelMapId));
  const message = useSelector(selectProcessMiningMessage(funnelMapId));

  const setLoading = useCallback(
    (isLoading: boolean) => {
      dispatch(setProcessMiningLoading({ funnelMapId, isLoading }));
    },
    [dispatch, funnelMapId],
  );

  const setError = useCallback(
    (errorMessage: string) => {
      dispatch(setProcessMiningError({ funnelMapId, error: errorMessage }));
    },
    [dispatch, funnelMapId],
  );

  const clearState = useCallback(() => {
    dispatch(clearProcessMiningState({ funnelMapId }));
  }, [dispatch, funnelMapId]);

  return {
    isLoading,
    isCompleted,
    error,
    setLoading,
    setError,
    clearState,
    message,
  };
};
